import React from 'react';
import { Modal } from 'react-bootstrap';
import QuizForm from './QuizForm';

/**
 * Create Quiz. The quiz does not exist yet, so the details, the mappings and
 * every question are staged in the form and sent together with POST /quiz-admin.
 */
const CreateQuizManagement = ({ show, onHide }) => (
    <Modal
        show={show}
        onHide={() => onHide(false)}
        size="xl"
        centered
        className="create-quiz-modal"
    >
        <Modal.Header closeButton style={{ borderBottom: '1px solid #E2E8F0' }}>
            <Modal.Title>Create Quiz</Modal.Title>
        </Modal.Header>

        <QuizForm
            mode="create"
            show={show}
            onClose={onHide}
        />
    </Modal>
);

export default CreateQuizManagement;
